import { createColor } from '@manakin/theme/lib/color';

const orange = createColor('#F39100');

export default orange;
